<template>
  <section id="examples" class="example-bg bg-no-repeat bg-cover bg-center text-white py-48 sm:py-64">
    <div class="container">
      <div class="examples-block leading-loose" v-html="htmlString"/>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    htmlString: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="sass" scoped>
.example-bg
  background-image: url("~assets/img/match/bg-golf-smal.svg")

.examples-block
  & > ::v-deep div
    flex-direction: column
    justify-content: space-between
    @media(min-width: theme('screens.md'))
      flex-direction: row

    & > div
      width: 100%
      padding-bottom: 1rem

      h2
        color: white

      @media(min-width: theme('screens.md'))
        width: 50%

        p, ul
          width: 75%
</style>
